import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, QueryList, ViewChildren, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FilterNavigationService } from './filter-navigation.service';
import { ActivatedRoute } from '@angular/router';
import { SearchObjectService } from '../../services/search-object.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { QueryTerms } from '../../models/QueryTerms';

@Component({
  selector: 'app-filter-navigation',
  templateUrl: './filter-navigation.component.html',
  styleUrls: ['./filter-navigation.component.scss']
})
export class FilterNavigationComponent implements OnInit, OnDestroy {

  @Input() page: string;
  @Input() resultSize: number;
  @Output() toggleMap = new EventEmitter<boolean>();
  @Output() outputFiltersSelected = new EventEmitter<boolean>();
  @Output() outputSearchCriteria = new EventEmitter();

  filterSubscription;
  navigationSubscription;
  filterDebounceSub: Subject<any> = new Subject();

  scrollObserver: IntersectionObserver;

  showMap = false;
  // showFilters = false;
  moreFilters = false;
  filterType = '';
  filters = [];
  filtersSelected = false;
  filtersSelectedNoDeselect = false;
  filtersSelectedLength = 0;
  filter;
  searchType: boolean;
  searchCriteria = {
    userInput: null,
    radius: null,
    address: null,
  };

  filterPastTop = false;
  numMoreFilters = 0;

  @ViewChild('ddFilterParent', { static: true} ) ddFilterParent: ElementRef;
  @ViewChildren('ddFilter') ddFilterArray: QueryList<ElementRef>;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.filterDebounceSub.next(this.filters);
  }

  constructor(public filterService: FilterNavigationService, private searchObjectService: SearchObjectService, private activatedRoute: ActivatedRoute) {
    this.filterSubscription = this.filterService.filtersAvailableChange.subscribe(() => {
      this.filters = this.filterService.getFilters().sort((a, b) => {
          return a.order > b.order ? 1 : ((b.order > a.order ? -1 : 0));
      });
      if (this.ddFilterArray) {
        this.ddFilterArray.notifyOnChanges();
        this.ddFilterArray.changes.subscribe(e => {
          if (this.filters.length > 0) {
            let i = 0;
            e.toArray().forEach(item => {
              if (this.filters[i]) {
                this.filters[i].html = item;
                i++;
              }
            });
          }
        });
      }
      this.filterDebounceSub.next(this.filters);
      this.filtersSelected = this.filterService.getSelected();
      this.filtersSelectedNoDeselect = this.filterService.getSelectedNoDeselect();
      this.searchCriteria = this.searchObjectService.getSearchCriteria();
      this.filtersSelectedLength = this.filterService.getSelectedLength();
      this.outputFiltersSelected.emit(this.filtersSelected);
    });

    this.filterDebounceSub.pipe(debounceTime(50)).subscribe(filters => {
      filters.forEach((item) => {
        this.handleOverflown(item);
      });
    });
  }

  ngOnInit() {
    const paramMap: any = this.activatedRoute.snapshot.queryParamMap;
    this.searchType = paramMap.params[QueryTerms.type] === 'find' || paramMap.params[QueryTerms.type] === 'shop';
    if (this.searchObjectService.isValidSearchObject()) {
      this.filterType = this.searchObjectService.getSearchTypeFilter();
      this.searchCriteria = this.searchObjectService.getSearchCriteria();
    }
  }


  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    if (this.scrollObserver) {
      this.scrollObserver.disconnect();
    }

    if (this.filterDebounceSub) {
      this.filterDebounceSub.unsubscribe();
    }

  }

  toggleMapClick(event: boolean) {
    this.toggleMap.emit(event);
    this.showMap = event;
  }

  // mobile list filter click events
  listFilterClick(obj) {
    if (obj.type === 'checkbox') {
      obj.checked = !obj.checked;
    } else if (obj.type === 'dropdown') {
      this.filter = obj;
    }
  }

  optionFilterBack() {
    this.filter = null;
  }

  optionFilterClick(filter, option) {
    filter.selected = option.Key;
    this.filterService.updateFilterData(filter, option);
    this.filter = null;
  }

  optionFilterReset(filter) {
    filter.selected = undefined;
    this.filter = null;
  }

  checkDDUpdate(obj) {
    if (obj.filter.type === 'checkbox') {
      obj.filter.checked = obj.key;
      this.applyFilters();
    } else if (obj.filter.type === 'checkbox-list') {
      const ddArray = obj.filter.ddData.filter(o => o.Key === obj.key);
      if (ddArray.length > 0) {
        ddArray[0].Checked = !ddArray[0].Checked;
      }
      this.applyFilters();
    } else if (obj.filter.type === 'dropdown') {
      obj.filter.selected = obj.key;
      this.filterService.updateFilterData(obj.filter, obj.key);
      this.applyFilters();
    }
  }

  checkDDUpdateMore(obj) {
    if (obj.filter.type === 'checkbox') {
      obj.filter.checked = obj.key;
    } else if (obj.filter.type === 'checkbox-list') {
      const ddArray = obj.filter.ddData.filter(o => o.Key === obj.key);
      if (ddArray.length > 0) {
        ddArray[0].Checked = !ddArray[0].Checked;
      }
    } else if (obj.filter.type === 'dropdown') {
      obj.filter.selected = obj.key;
      this.filterService.updateFilterData(obj.filter, obj.key);
    }
  }

  applyMore(e) {
    this.showLessFilters();
    this.applyFilters();
  }

  clearAllMore(e) {
    this.showLessFilters();
    this.removeFilters(e);
  }

  updateFilterClick(filter) {
    if (filter.type === 'checkbox') {
      filter.checked = !filter.checked;
    }

    this.applyFilters();
  }

  dropdownFilterClick(filter) {
    filter.showDropdown = !filter.showDropdown;
  }

  applyFilters() {
    this.filterService.updateFilters(this.searchType);
  }

  removeFilters(more?) {
    this.filters.forEach((obj) => {
      if (more === 'tablet') {
        if (obj.type === 'checkbox-list' && obj.movetoMore) {
          obj.ddData.forEach((option) => {
            if (option.Key === 'people' || option.Key === 'places') {
              option.Checked = true;
            } else {
              option.Checked = false;
            }
          });
        } else if (obj.movetoMore) {
          obj.checked = false;
          obj.selected = undefined;
        }
      } else {
        if (obj.type === 'checkbox-list') {
          obj.ddData.forEach((option) => {
            if (option.Key === 'people' || option.Key === 'places') {
              option.Checked = true;
            } else {
              option.Checked = false;
            }
          });
        } else {
          obj.checked = false;
          obj.selected = undefined;
        }
      }
    });
    this.filterService.updateFilters(this.searchType);
  }

  showLessFilters(cancel?) {
    this.moreFilters = false;
    if (cancel) {
      this.filterService.filtersAvailableChange.next(null);
    }
  }

  toggleMoreFilters() {
    this.filterDebounceSub.next(this.filters);
    this.moreFilters = !this.moreFilters;
    if (!this.moreFilters) {
      this.filterService.filtersAvailableChange.next(null);
    }
  }

  clickSearchCriteria(e) {
    this.outputSearchCriteria.emit(e);
  }


  // handle filters that are hidden
  handleOverflown(filter) {
    let moreFilters = 0;
    if (filter) {
      if (filter.html) {
        if (filter.html.nativeElement.offsetTop > this.ddFilterParent.nativeElement.offsetTop) {
          filter.movetoMore = true;
          moreFilters++;
        } else {
          filter.movetoMore = false;
        }
      }
    }

    this.numMoreFilters = moreFilters;

  }

}
